export enum ChartJsColors {
	DarkGreen = 'rgb(65, 195, 0)',
	LightGreen = 'rgb(144, 238, 2)',
	DarkBlue = 'rgb(0, 133, 227)',
	LightBlue = 'rgb(175,216,248)',
	DarkOrange = 'rgb(232, 153, 42)',
	LightOrange = 'rgb(237,194,64)'
}
